import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
const Tsucc = (props) => {
  const { apiUrl, history } = props;
  let orderId = new URL(window.location.href).searchParams.get('orderId');
  let paymentKey = new URL(window.location.href).searchParams.get('paymentKey');
  let amount = new URL(window.location.href).searchParams.get('amount');

  console.log(orderId, paymentKey, amount);

  const _callApi = async () => {
    const result = await axios.post(apiUrl + '/exhibitionPay', {
      orderId,
      paymentKey,
      amount,
    });

    const intReturn = result.data[0].intReturn;
    const data = result.data[0].data;
    console.log(data);
    if (intReturn === 0) {
      //alert("정상결제...");
      toast.success('예매가 성공적으로 완료되었습니다.');
      history.push(`/reserve/${orderId}`);
      // history.push("/event/323");
    } else if (intReturn === -1) {
      toast.error('결제정보가 누락되었습니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-1'}&message=${'결제정보가 누락.'}`
      );
    } else if (intReturn === -2) {
      toast.error('회차당 총 예매수량을 초과하였습니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-2'}&message=${'차당 총 예매수량을 초과.'}`
      );
      // alert("트랙잭션 롤백");
    } else if (intReturn === -3) {
      toast.error('예매일이 아닙니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-3'}&message=${'예매일이 아닙니다.'}`
      );
    } else if (intReturn === -5) {
      toast.error('회차당 인당 예매수를 초과하였습니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-3'}&message=${'회차당 인당 예매수를 초과.'}`
      );
    } else if (intReturn === -4) {
      toast.error('결제금액이 일치하지 않습니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-3'}&message=${'결제금액 불일치.'}`
      );
    } else if (intReturn === -100) {
      toast.error('통신 오류가 발생했습니다.');
      history.push(
        `/tfail?orderId=${orderId}&code=${'-100'}&message=${'통신오류'}`
      );
    } else if (intReturn === -200) {
      toast.error(data.message);
      history.push(
        `/tfail?orderId=${orderId}&code=${'-200'}&message=${data.message}`
      );
      // alert(data.message);
    }

    //
  };

  useEffect(() => {
    _callApi();
  }, []);

  return (
    <div></div>
    // <div style={{ backgroundColor: "#fff" }}>
    //   <div>
    //     <div>선택 내역</div>
    //     <div>날짜: 2023.11.01(목)</div>
    //     <div>시간: 2회 오후 12시 00분</div>
    //     <div>매수: 2매</div>
    //   </div>
    //   <div>
    //     <div>결제 내역</div>
    //     <div>결제수단: 신한카드</div>
    //     <div>결제일: 202300502 17:29</div>
    //   </div>
    // </div>
  );
};

export default shopContext(withRouter(Tsucc));
